import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { refreshToken } from "../api/authApi";
import { getPrimaryRoleName } from "../utils/authUtils";
import { tokenService } from "../services/TokenService";
import { toast } from "sonner";
import { ROLES } from "../constant/roles";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Check for error parameter in URL
        const urlError = searchParams.get("error");
        if (urlError) {
          const errorMessage = decodeURIComponent(urlError);
          toast.error(errorMessage);
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        // Call refresh token API directly
        const refreshData = await refreshToken();

        if (refreshData?.success && refreshData?.accessToken && refreshData?.user) {
          // Save token with expiry for subsequent requests
          tokenService.setToken(refreshData.accessToken, refreshData.expiresIn);

          // Map backend role to local role using utility function
          const roleName = getPrimaryRoleName(refreshData.user.roles);
          const mappedRole = roleName === ROLES.ADMIN
            ? ROLES.ADMIN
            : roleName === ROLES.INSTRUCTOR || roleName === "teacher"
            ? ROLES.INSTRUCTOR
            : ROLES.STUDENT;

          // Store user data in localStorage (following existing pattern)
          const newUser = {
            id: refreshData.user.id,
            name: refreshData.user.name,
            email: refreshData.user.email,
            role: mappedRole,
          };

          try {
            localStorage.setItem("auth_user", JSON.stringify(newUser));
          } catch {}

          toast.success("Login successful!");
          setTimeout(() => navigate("/dashboard"), 1000);
        } else {
          throw new Error("Failed to retrieve authentication data");
        }
      } catch (err) {
        console.error("Auth callback error:", err);
        toast.error("Authentication failed. Please try logging in again.");
        setTimeout(() => navigate("/login"), 2000);
      }
    };

    handleAuthCallback();
  }, [navigate, searchParams]);

  // Minimal loading state
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f8fa]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-bits-blue border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-muted-foreground">Processing login...</p>
      </div>
    </div>
  );
}